export * from '../jquery/jquery.service';
export * from '../core/common/services/componentesjs.service';
export * from '../loader/loader.service';
export * from '../config/config.service';
export * from '../header/header.service';

export * from '../pesquisa/pesquisa.service';
export * from '../mapa/mapa.service';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/lib/service.ts
 **/